import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';

const LazyMCPSuccess = lazy(() => import('./-mcp-success').then((module) => ({ default: module.MCPSuccess })));

const MCPSuccessRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyMCPSuccess />
  </Suspense>
);

export const Route = createFileRoute('/signup/mcp/success')({
  component: MCPSuccessRouteComponent,
});
